export interface ParsedEnv {
  key: string;
  value: string;
}

/**
 * Parses a pasted `.env` blob. Supports `KEY=VALUE`, `export KEY=VALUE`,
 * `#` comments, blank lines, and single or double quoted values.
 */
export function parseEnvText(text: string): { vars: ParsedEnv[]; invalidLines: number[] } {
  const vars: ParsedEnv[] = [];
  const invalidLines: number[] = [];

  text.split(/\r?\n/).forEach((rawLine, index) => {
    const line = rawLine.trim();
    if (line === "" || line.startsWith("#")) return;

    const withoutExport = line.startsWith("export ") ? line.slice(7).trim() : line;
    const separator = withoutExport.indexOf("=");
    if (separator <= 0) {
      invalidLines.push(index + 1);
      return;
    }

    const key = withoutExport.slice(0, separator).trim();
    if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(key)) {
      invalidLines.push(index + 1);
      return;
    }

    vars.push({ key, value: unquote(withoutExport.slice(separator + 1).trim()) });
  });

  return { vars, invalidLines };
}

function unquote(value: string): string {
  if (value.length >= 2 && value.startsWith('"') && value.endsWith('"')) {
    return value.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
  }
  if (value.length >= 2 && value.startsWith("'") && value.endsWith("'")) {
    return value.slice(1, -1);
  }
  return value;
}

export function toEnvText(vars: { key: string; value: string | null; isSecret: boolean }[]): string {
  return vars
    .map(({ key, value, isSecret }) =>
      value === null && isSecret ? `${key}=<secret, unchanged>` : `${key}=${value ?? ""}`,
    )
    .join("\n");
}
